function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8823 24.9975C14.0606 34.7704 19.6143 42.3841 19.6143 42.3841C21.6569 41.7679 25.5556 38.8876 25.5556 38.8876C25.5556 42.3841 23.4984 49.995 23.4984 49.995C23.4984 49.995 30.6999 44.4267 32.9668 35.1783C35.2308 25.9299 28.6544 16.6451 28.6544 16.6451C29.0507 23.1909 26.8362 29.629 22.4975 34.5475C22.7146 34.2969 22.8967 34.0186 23.0366 33.717C23.816 32.1582 25.0675 28.1065 24.3347 18.7241C23.3032 5.5537 11.3697 0 11.3697 0C12.3983 8.02461 9.31404 9.87341 2.08927 25.1053C-5.1355 40.3343 8.69632 49.9994 8.69632 49.9994C3.13824 31.6847 14.8823 24.9975 14.8823 24.9975Z",
  transform: "matrix(-1 2.1456883E-07 2.1456883E-07 1 33.441406 0)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
});

var SvgCodeigniter = function SvgCodeigniter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "50px",
    viewBox: "0 0 34 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCodeigniter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/codeigniter.ea3121da.svg";
export { ForwardRef as ReactComponent };